/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../Tema";
import logo from '../Recursos/logo_blanco.svg'
import {REDES, SECCIONES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../Utilidades/useIrRuta";
import {irUrl} from "../Utilidades/irUrl";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../App";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";
import {obtenerIndicativo} from "../Modulo_formularios/Funciones/obtenerIndicativo";
import {limpiarCelular} from "../Modulo_formularios/Funciones/limpiarCelular";
import {actualizarDoc} from "../Servicios/BD/actualizarDoc";


const Footer = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const {ir, Aviso} = useIrRuta()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [espacios, setEspacios] = useState([])
    const [politicas, setPoliticas] = useState([])


    const bajarDatos = async () => {


        let dox = await obtenerCol('potencialesEspacios')
        let data = dox.data
        bajarJson(data, 'Inscritos.json')

    }

    const bajarJson = (data, fileName = 'data.json') => {
        // 1. Convertir el objeto a una cadena JSON formateada
        const jsonString = JSON.stringify(data, null, 2);

        // 2. Crear un Blob con el contenido y el tipo MIME correcto
        const blob = new Blob([jsonString], {type: 'application/json'});

        // 3. Crear una URL temporal para el Blob
        const url = URL.createObjectURL(blob);

        // 4. Crear un elemento <a> invisible para forzar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;

        // 5. Simular el click y limpiar
        document.body.appendChild(link);
        link.click();

        // Limpieza: eliminamos el link y liberamos la URL de memoria
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const colocarIndicativoeId = async () =>{

        let dox = await obtenerCol('potencialesEspacios')
        let data = dox.data

        for (let i = 1; i < data.length; i++) {
            let usu = data[i]
            let obj ={
                notificaciones: true,
                indicativo: obtenerIndicativo(usu.pais),
                idEspacio: '1778701801210IOS',
                celular: limpiarCelular(usu.celular)
            }

            await actualizarDoc('potencialesEspacios', usu.id, obj)
        }

    }

    useEffect(() => {


        if (cData && cData.espacios.length > 0) {
            setEspacios(cData.espacios);
        }

        if (cData && cData.politicas.length > 0) {
            setPoliticas(cData.politicas);
        }


    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Aviso/>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mb: -5, mt: 5}}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: 6,
                        p: sCell ? 4 : 8,
                        color: '#fff'
                    }}
                >

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 4}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={200} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography>Empieza o sigue tu proceso acompañado de un profesional </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                            spacing={1}
                        >

                            {REDES.map((item, index) => (
                                <IconButton
                                    onClick={() => irUrl(item.url)}
                                    sx={{backgroundColor: theme.palette.secondary.main, width: 48, height: 48}}>
                                    <img src={item.img}/>
                                </IconButton>
                            ))}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 3}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 20,
                                fontWeight: 800,
                                color: theme.palette.secondary.main
                            }}>Profesionales</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {espacios.map((item, index) => {


                                    if (index < 4) {


                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography sx={{
                                                    fontSize: 18,
                                                    fontWeight: 500,
                                                    lineHeight: 1.1
                                                }}>{item.profesional}</Typography>
                                            </Grid>
                                        )
                                    }
                                }
                            )}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 3}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 20,
                                fontWeight: 800,
                                color: theme.palette.secondary.main
                            }}>Politicas</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {politicas.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography
                                        onClick={() => abrir(item)}
                                        sx={{fontSize: 18, fontWeight: 500, cursor: 'pointer'}}>{item.titulo}</Typography>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 2}}
                        sx={{mt: sCell ? 4 : 0}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 20, fontWeight: 800, color: theme.palette.secondary.main}}>Link
                                Rapidos</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2}}
                        >

                            {SECCIONES.map((item, index) => (
                                <Grid
                                    onClick={() => ir(item)}
                                    container size={{xs: 12, sm: 12, md: 12}}
                                    sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 500}}>{item}</Typography>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{borderTop: 1, borderColor: '#fff', color: '#fff', mt: 4}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: 4, mb: sCell ? 4 : 0}}>
                            <Typography>© Creencia Central | 2026 - 2027</Typography>
                        </Grid>

                        {/*}  <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Button
                                onClick={() => colocarIndicativoeId()}
                            >
                                ESte
                            </Button>
                        </Grid> */}

                    </Grid>


                </Grid>


            </Grid>

        </Grid>
    )

}
export default Footer
